import { Box } from "@mui/material";
import { HRService } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import LevelForm from "./LevelForm";
import { allLevels } from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;

const actions = {
  entity: "Level",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};

const LevelColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "name", headerName: "Level Name", flex: 1 },
  { field: "createdBy", headerName: "Created By", flex: 0.8 },
  { field: "createdDate", headerName: "Created Date", flex: 1 },
  { field: "updatedBy", headerName: "Updated By", flex: 0.8 },
  { field: "updatedDate", headerName: "Updated Date", flex: 1 },
];

function LevelTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Levels"
        subtitle="View, create and edit levels."
        columns={LevelColumns}
        FormComponent={LevelForm}
        actions={actions}
        query={allLevels}
        base_url={base_url}
      />
    </Box>
  );
}

export default LevelTable;
